import { useQuery } from '@tanstack/react-query';
import type { AgentApiSharedJobPostSyncRequestsItem } from '@/types/serializers';

type Options = {
  pollWhileStatusIn?: AgentApiSharedJobPostSyncRequestsItem['status'][];
};

export default function useFetchSharedJobPostSyncRequest(
  encryptId: string | null | undefined,
  options?: Options
) {
  return useQuery({
    queryKey: ['SharedJobPostSyncRequest', encryptId],
    queryFn: async (): Promise<AgentApiSharedJobPostSyncRequestsItem> => {
      const response = await fetch(`/agent/api/shared_job_post_sync_requests/${encryptId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('取り込みリクエストの取得に失敗しました');
      }

      return response.json();
    },
    enabled: !!encryptId,
    gcTime: 0,
    staleTime: 0,
    refetchInterval: (query) => {
      const currentStatus = query.state.data?.status;
      if (options?.pollWhileStatusIn && currentStatus) {
        if (options.pollWhileStatusIn.includes(currentStatus)) {
          return 2000;
        }
        return false;
      }
      return false;
    },
    refetchIntervalInBackground: true,
  });
}
